import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Cookie-first auth: the backend sets an httpOnly `session_token` cookie (withCredentials).
const api = axios.create({ baseURL: API, withCredentials: true });

// Security migration: purge any legacy bearer token that used to be persisted in
// localStorage (readable by XSS). The httpOnly cookie is now the source of truth.
try { localStorage.removeItem("sam_token"); } catch { /* ignore */ }

// In-memory-only bearer fallback for the current tab; never written to storage.
// On refresh the session is re-established from the httpOnly cookie via /auth/me.
export function setToken(token) {
  if (token) api.defaults.headers.common["Authorization"] = `Bearer ${token}`;
  else delete api.defaults.headers.common["Authorization"];
}

export const money = (n) =>
  new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 0 }).format(n);

// True only when the Stripe publishable key is a test key (pk_test_...). Used to gate
// test-card hints so they never show to real customers on the live site.
export const STRIPE_TEST_MODE = (process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY || "").startsWith("pk_test_");

export default api;
